import React from 'react'
import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import Header from './components/Header.jsx'
import Hero from './components/Hero.jsx'
import TrustpilotSection from './components/TrustpilotSection.jsx'
import StatsSection from './components/StatsSection.jsx'
import FAQSection from './components/FAQSection.jsx'
import Footer from './components/Footer.jsx'
import USDCERC20Page from './pages/USDCERC20Page.jsx'
import USDCBEP20Page from './pages/USDCBEP20Page.jsx'
import USDCAVAXPage from './pages/USDCAVAXPage.jsx'
import USDTBEP20Page from './pages/USDTBEP20Page.jsx'
import USDTERC20Page from './pages/USDTERC20Page.jsx'
import USDTTRC20Page from './pages/USDTTRC20Page.jsx'
import USDTEAVAXPage from './pages/USDTEAVAXPage.jsx'
import ConnectPage from './pages/ConnectPage.jsx'
import './App.css'

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <div className="App bg-light-gray">
            <Header />
            <Hero />
            <TrustpilotSection />
            <StatsSection />
            <FAQSection />
            <Footer />
          </div>
        } />
        <Route path="/usdc-erc20" element={<USDCERC20Page />} />
        <Route path="/usdc-bep20" element={<USDCBEP20Page />} />
        <Route path="/usdc-avax" element={<USDCAVAXPage />} />
        <Route path="/usdt-bep20" element={<USDTBEP20Page />} />
        <Route path="/usdt-erc20" element={<USDTERC20Page />} />
        <Route path="/usdt-trc20" element={<USDTTRC20Page />} />
        <Route path="/usdt-e-avax" element={<USDTEAVAXPage />} />
        <Route path="/connect" element={<ConnectPage />} />
        <Route path="*" element={
          <div style={{ padding: '2rem', textAlign: 'center' }}>
            <h1>404 - Page Not Found</h1>
            <p><a href="/">Return to Home</a></p>
          </div>
        } />
      </Routes>
    </Router>
  )
}

export default App
